module.exports = __webpack_public_path__ + "img/15.77faa62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/15.png
// module id = Cjhm
// module chunks = 1